import * as React from 'react'
import { compose } from 'redux'
import SVG from 'react-inlinesvg'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as moment from 'moment'
import classnames from 'classnames'
import { DATE_FORMAT_FULL } from '@App/constantes'
import ORGANISATION from 'assets/icon-organisation.svg'
import PROFIL from 'assets/icon-profil.svg'
import USERS from 'assets/icon-users-2.svg'

import CONSOLE from 'assets/icon-console.svg'
import STUDIO from 'assets/icon-studio.svg'
import CLASSIFY from 'assets/icon-classify.svg'
import BISIGHT from 'assets/icon-bisight.svg'
import ANALYZER from 'assets/icon-analyzer.svg'
import {
  Title,
} from 'relevant-ui'
import './styles.scss'

const Applications = ({ data }: any) => {
  return (
    <div className="container-app">
      <a
        className={classnames({
          application: true,
          'application--manage': data && data.label === 'MANAGEMENT_API',
        })}
        href={data && data.url}
      >
        <SVG
          src={data?.icon ? data.icon : CLASSIFY}
          style={{ fill: '#505F79' }}
        />
      </a>
      <div className="label">{data && data.name}</div>
    </div>
  )
}

const HomepagePage: any = ({
  user,
}: any) => {

  const AdminList = [
    {
      name: 'Gérer le profil',
      url: '/update-profile',
      icon: PROFIL,
      role: 0,
    },
    {
      name: 'Utilisateurs',
      url: '/users',
      icon: USERS,
      role: 100,
    },
    {
      name: 'Organisations',
      url: '/applications',
      icon: ORGANISATION,
      role: 100,
    },
  ]

  const applications =
    user &&
    user?.applications
      ?.filter(
        (item: any) => item.name !== 'Retargeting' && item.name !== 'Connect',
      )
      ?.map((item: any) => {
        if (item.label === 'MANAGEMENT_API') {
          return {
            ...item,
            icon: CONSOLE,
          }
        }

        if (item.label === 'ANALYZER') {
          return {
            ...item,
            icon: ANALYZER,
          }
        }

        if (item.label === 'STUDIO') {
          return {
            ...item,
            icon: STUDIO,
          }
        }

        if (item.label === 'BISIGHT') {
          return {
            ...item,
            icon: BISIGHT,
          }
        }

        if (item.label === 'CLASSIFY_API') {
          return {
            ...item,
            icon: CLASSIFY,
          }
        }

        if (item.label === 'AD_MANAGER') {
          return {
            ...item,
            icon: CLASSIFY,
          }
        }

        return null
      })

  return (
    <div className="section">
      <div className="applications">
        <Title title="Vos applications" style={{ marginBottom: '45px' }} />
        <div className="applications__list row">
          {applications?.map((item: any) => (
            <Applications
              key={`APPLICATIONS_${item && item.name}`}
              icon={item?.icon}
              data={item}
            />
          ))}
        </div>
      </div>
      <div className="applications">
        <Title title="Administration" style={{ marginBottom: '45px' }} />

        <div className="applications__list row">
          { AdminList
            ?.filter(item => item.role <= user.role?.value)
            ?.map((item: any) => (
              <Applications
                key={`ADMINISTRATION_${item && item.name}`}
                data={item}
              />
            ))}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: any) => {
  const {
    user: {
      user,
    },
    user: {
      user: {
        createdAt,
      },
    },
  } = state

  const accountCreatedAt = moment(createdAt).format(DATE_FORMAT_FULL)

  return {
    user,
    accountCreatedAt,
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, null),
)(HomepagePage)
